import styled from "styled-components"

const LowerInfoStyled = styled.div`
    position: relative;
    height: 50%;
    width: 100%;

    display: flex;
    flex-direction: row;
    gap: 10%;
    padding: 2.5%;

    & > div {
        position: relative;
        width: 45%;
        heigth: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        div.headers {
            position: relative;
            width: 100%;
        
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }
`

export {LowerInfoStyled}